import React, { useEffect, useState, useContext } from 'react';
import { ConfigContextUtils } from '../context/contextUtils.context';
import entregaFunction from '../views/entrega/entrega.functions';
//import utils from '../utils/utils.functions';
import notification from './notification.component';

const EntregaModal = ({ onClose, data, config, show, onUpdate }) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const [observacion, setObservacion] = useState({
    text: '',
  });

  const setValue = (e) => {
    setObservacion({
      ...observacion,
      text: e.target.value,
    })
  }

  useEffect(() => {
    setObservacion({
      text: '',
    });
  },[show])

  const entrega = () => {
    setPreloader(true);
    entregaFunction.entrega({
      observacion: observacion.text,
      id: data.id,
      email: data.email,
      fila: data,
    }).then((respuesta) => {
      if (respuesta.data.guia_finalizada) {
        notification.success();
        onUpdate(respuesta.data.fila);
      } else {
        notification.warning('El cambio no puede ser efectuado.');
      }
      setPreloader(false);
    })
  }

  return (
    <div>
      <div className="grupo-input">
      <h4>¿ Marcar la guia {config.prefijo_correlativo_guia}-{data.guia_paquete} como entregado ?</h4>
      </div>
      <div className="grupo-input mb-2">
          <small>Información adicional (Opcional)</small>
          <div className="d-flex">
            <input type="text"
              className={`form-control input-border`}
              name="observacion"
              placeholder="Describa el estado de entrega de la encomienda"
              onChange={setValue}
              value={observacion.text}
            />
          </div>
        </div>
      <div style={{ color: 'red', fontSize: 12 }}>
        ¡Importante! Verifique bien la información antes de confirmar, recuerde que los clientes seran notificados del cambio del estado de su guia.
      </div>
      <div className="mt-2">
        <button onClick={onClose} type="button" className="btnx btnx-warn">Cerrar</button> {' '}
        <button onClick={entrega} type="button" className="btnx btnx-warn">Confirmar cambio de estado</button>
      </div>
    </div>
  )
}

export default EntregaModal;